import React, { Component } from 'react'
import { Container, Row, Col, Tabs, Tab, Table } from 'react-bootstrap'

import Footer from './Footer'
import HeaderTop from './HeaderTop'
import SideNavTop from './SideNavTop'
import '../Accueil.css'


class CampHiver extends Component {
    state = {
        redirect: false,
        search: '',
        key: 'maitre'
    }

    handleCHange = event => {
        const { name, value } = event.target
        this.setState({ [name]: value })
    }

    handleSubmit = event => {
        //on gere le form
        event.preventDefault()
        this.props.history.push(`/recherche/${this.state.search}`);

    }

    setRedirect = () => {
        this.setState({
          redirect: true
        })
      }

    handleSubmitFacebbok = () => {
        if (this.state.redirect) {
            window.location.href = "https://www.facebook.com/clubCAPN/";
        }
    }

    handleSelect(key) {
        if (key === "maitre")
            this.props.history.push(`/competiton/maitres-nageurs`);
        else if (key === "natation")
            this.props.history.push(`/competiton/natation`);
        else if (key === "sauvetage")
            this.props.history.push(`/competiton/sauvetage-sportif`);
        else if (key === "resultat")
            this.props.history.push(`/competiton/resultats`);
        else if (key === "synchro")
            this.props.history.push(`/competiton/nage-synchronisee`);
    }

    render() {
        console.log(this.state.key)
        return (
            <>
                <Container fluid>
                <Row>
            <SideNavTop/>
            <Col lg={10} md={12} sm={12} xs={12} id="page-content-wrapper" className="nopadding">
              <HeaderTop
                handleSubmit={this.handleSubmit}
                handleCHange={this.handleCHange}
                handleSubmitFacebbok={this.handleSubmitFacebbok}
                setRedirect={this.setRedirect}
              />

                            <Col lg={12} md={12} sm={12} xs={12} className="nopadding">

                                <Tabs
                                    id="controlled-tab"
                                    activeKey={this.state.key}
                                    onSelect={key => this.handleSelect(key)}
                                >                       <Tab eventKey="maitre" title="Maître Nageurs">
                                    </Tab>
                                    <Tab eventKey="synchro" title="Nage synchronisée">
                                    </Tab>
                                    <Tab eventKey="natation" title="Natation" >
                                    </Tab>
                                    <Tab eventKey="sauvetage" title="Sauvetage sportif">
                                    </Tab>
                                    <Tab eventKey="resultat" title="Résultat Compétition" >
                                    </Tab>
                                </Tabs>
                            </Col>


                            <Col lg={12} md={12} sm={12} xs={12} className="nopadding">
                                <Row>
                                    <Col lg={12} md={12} sm={12} xs={12} className="nopadding">
                                        <div className="histoire-content">
                                            <h1><span>Camp de la relâche 2018</span></h1>
                                            <h2>Programmation</h2>
                                            <p className="pCenter">5 au 9 mars 2018</p>

                                            <h2>Vous devez avoir en main lors de l'inscription :</h2>
                                            <p className="pCenter"> - la date de naissance de l'enfant<br />
                                            - le numéro d'assurance maladie du campeur (obligatoire pour effectuer l'inscription)<br />
                                            - le niveau de natation<br />
                                            - l'adresse complète<br />
                                            - le numéro d'assurance sociale du parent<br />
                                            - le paiement en argent comptant ou par chèque<br />
                                            - si paiement par carte de crédit des frais de 4% sont applicables<br /><br />
                                            </p>

                                            <h2>Horaire type d'une semaine de camp de jour</h2>

                                            <Table striped bordered hover>
                                            <thead>
                                                <tr>
                                                <th></th>
                                                <th className="table-resp">Lundi</th>
                                                <th className="table-resp-Camp">Lundi-Mardi-Mercredi-Vendredi</th>

                                                <th className="table-resp">Mardi</th>
                                                <th className="table-resp">Mercredi</th>
                                                <th>Jeudi</th>
                                                <th className="table-resp">Vendredi</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>9h00 à 9h30</td>
                                                    <td>Accueil des jeunes</td>
                                                    <td className="table-resp">Accueil des jeunes</td>
                                                    <td className="table-resp">Accueil des jeunes</td>
                                                    <td>Accueil des jeunes</td>
                                                    <td className="table-resp">Accueil des jeunes</td>
                                                </tr>
                                                <tr>
                                                    <td>9h30 à 9h45</td>
                                                    <td>On se change pour aller faire des courses</td>
                                                    <td className="table-resp">On se change pour aller faire des courses</td>
                                                    <td className="table-resp">On se change pour aller faire des courses</td>
                                                    <td rowspan="7">Sortie*!!!</td>
                                                    <td className="table-resp">On se change pour aller faire des courses</td>
                                                </tr>
                                                <tr>
                                                    <td>9h45 à 10h45</td>
                                                    <td>Cours de natation</td>
                                                    <td className="table-resp">Cours de natation</td>
                                                    <td className="table-resp">Cours de natation</td>
                                                    <td className="table-resp">Cours de natation</td>
                                                </tr>
                                                <tr>
                                                    <td>10h45 à 11h30</td>
                                                    <td>Baignade libre</td>
                                                    <td className="table-resp">Baignade libre</td>
                                                    <td className="table-resp">Baignade libre</td>
                                                    <td className="table-resp">Baignade libre</td>
                                                </tr>
                                                <tr>
                                                    <td>11h30 à 12h00</td>
                                                    <td>On se change!</td>
                                                    <td className="table-resp">On se change!</td>
                                                    <td className="table-resp">On se change!</td>
                                                    <td className="table-resp">On se change!</td>
                                                </tr>
                                                <tr>
                                                    <td>12h00 à 13h00</td>
                                                    <td>Diner!</td>
                                                    <td className="table-resp">Diner!</td>
                                                    <td className="table-resp">Diner!</td>
                                                    <td className="table-resp">Diner!</td>
                                                </tr>
                                                <tr>
                                                    <td>13h00 à 15h45</td>
                                                    <td>Jeux sportifs</td>
                                                    <td className="table-resp">Jeux sportifs</td>
                                                    <td className="table-resp">Jeux sportifs</td>
                                                    <td className="table-resp">Jeux sportifs</td>
                                                </tr>
                                                <tr>
                                                    <td>15h45 à 16h00</td>
                                                    <td>Collation et au revoir</td>
                                                    <td className="table-resp">Collation et au revoir</td>
                                                    <td className="table-resp">Collation et au revoir</td>
                                                    <td className="table-resp">Collation et au revoir</td>
                                                </tr>
                                            </tbody>
                                            </Table>
                                           

                                        </div>
                                    </Col>
                                </Row>
                            </Col>

                            <Col lg={12} md={12} sm={12} xs={12} className="nopadding">
                                <Footer />
                            </Col>
                        </Col>
                    </Row>
                </Container>
            </>
        )
    }
}

export default CampHiver
